import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin-auth-component',
  imports: [CommonModule, ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule],
  templateUrl: './admin-auth-component.html',
  styleUrl: './admin-auth-component.scss'
})
export class AdminAuthComponent {
  private dialogRef = inject(MatDialogRef<AdminAuthComponent>);
  private fb = inject(FormBuilder);

  form: FormGroup = this.fb.group({
    password: ['', Validators.required]
  });

  error = false;

  submit() {
    const value = this.form.value.password;
    if (value === environment.adminPassword) {
      localStorage.setItem('auth', environment.tokenAuth);
      this.dialogRef.close(true);
    } else {
      this.error = true;
    }
  }

  exit() {
    this.dialogRef.close(false);
  }
}
